module.exports = __webpack_public_path__ + "static/img/部件组成4-作业控制.f011cda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type2-1/部件组成4-作业控制.png
// module id = z/vt
// module chunks = 0